import { Box, Skeleton } from 'hephaestus/web';

const SKELETON_ROW_COUNT = 6;

export const PortfoliosTabSkeleton = () => (
  <Box>
    {Array.from({ length: SKELETON_ROW_COUNT }, (_, i) => (
      <Box
        key={i}
        sx={{
          display: 'flex',
          gap: 2,
          px: 2,
          py: 1.5,
        }}
      >
        <Skeleton variant='rectangular' width={18} height={18} />
        <Skeleton variant='text' sx={{ flex: 1 }} />
        <Skeleton variant='text' width='10%' />
        <Skeleton variant='text' width='8%' />
        <Skeleton variant='text' width='12%' />
        <Skeleton variant='text' width='10%' />
      </Box>
    ))}
  </Box>
);
